import { render, staticRenderFns } from "./k-tag.vue?vue&type=template&id=b9e3297a&"
import script from "./k-tag.vue?vue&type=script&lang=ts&"
export * from "./k-tag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports